export default __webpack_public_path__ + "static/media/vision.08d3bc03.jpg";